export default __webpack_public_path__ + "static/03-31a179441f8bcf39eb57d43b8671911e.jpg";